import { OpsOrderCarrier } from '@/graphql/generatedTypes';

/**
 * Display names for carriers whose enum value is not what ops calls them.
 * Proper nouns, so they are intentionally not translated — same in every locale
 * (matching CARRIER_SERVICE_LABELS in the order sidebar).
 */
const CARRIER_DISPLAY_NAMES: Partial<Record<OpsOrderCarrier, string>> = {
  [OpsOrderCarrier.Manual]: "Ho'i Ops",
  [OpsOrderCarrier.Others]: 'Logistic Partner',
};

export function carrierLabel(carrier: OpsOrderCarrier | string): string {
  return CARRIER_DISPLAY_NAMES[carrier as OpsOrderCarrier] ?? String(carrier);
}

// MANUAL and OTHERS ship outside SendCloud: no label, no address validation.
// Every other carrier is a parcel carrier that goes through SendCloud, which is
// when the delivery address has to be complete and editable.
const LABELLESS_CARRIERS: ReadonlySet<OpsOrderCarrier> = new Set([
  OpsOrderCarrier.Manual,
  OpsOrderCarrier.Others,
]);

export function isSendCloudCarrier(
  carrier: OpsOrderCarrier | string | null | undefined,
): boolean {
  return !!carrier && !LABELLESS_CARRIERS.has(carrier as OpsOrderCarrier);
}
